module.exports = __webpack_public_path__ + "img/1.23bbfa73.png";